import React from 'react';

const DuplicateIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>Duplicate</title>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M9.5 5.15V7.1h14.49a1 1 0 0 1 1 1v15.594h2a1 1 0 0 0 1-1V5.15a1 1 0 0 0-1-1H10.5a1 1 0 0 0-1 1z"
        fillRule="nonzero"
      />
      <path d="M21.818 28H6a1 1 0 0 1-1-1V9.912a1 1 0 0 1 1-1h15.818a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1z" />
    </g>
  </svg>
);

const EditIcon: React.FC = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    style={{ height: '20px' }}
  >
    <title>Edit</title>
    <path
      d="M5.857 20.878L19.868 6.866l.01-.009 5.265 5.265-14.011 14.012-.01.009-5.265-5.265zm-1.589 1.408l5.446 5.446-.015.004.006.005L2 30l2.259-7.705.005.006.004-.015zM28.091 5.008a3.106 3.106 0 0 1-.001 4.393l-.01.009-.777.777-.517.518-.01.01-5.49-5.491.786-.787.528-.527a3.106 3.106 0 0 1 4.392 0l1.099 1.098z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

const GrayEditIcon: React.FC = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    style={{ height: '20px' }}
  >
    <title>Edit Disabled</title>
    <path
      d="M5.857 20.878L19.868 6.866l.01-.009 5.265 5.265-14.011 14.012-.01.009-5.265-5.265zm-1.589 1.408l5.446 5.446-.015.004.006.005L2 30l2.259-7.705.005.006.004-.015zM28.091 5.008a3.106 3.106 0 0 1-.001 4.393l-.01.009-.777.777-.517.518-.01.01-5.49-5.491.786-.787.528-.527a3.106 3.106 0 0 1 4.392 0l1.099 1.098z"
      fill="#616668"
      fillRule="nonzero"
    />
  </svg>
);

const AssignIcon: React.FC = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    style={{ height: '20px' }}
  >
    <title>Assign</title>
    <path
      d="M27.102 28.552c-.96.965-2.153 1.448-3.576 1.448-1.642 0-3.071-.61-4.287-1.832L5.062 13.948C3.687 12.543 3 10.888 3 8.982c0-1.943.669-3.592 2.007-4.948C6.345 2.678 7.981 2 9.915 2c1.922 0 3.582.69 4.981 2.07l11.039 11.105a.561.561 0 0 1 .182.404c0 .195-.185.479-.556.852-.371.372-.654.559-.849.559a.576.576 0 0 1-.42-.184L13.237 5.683c-.961-.94-2.062-1.41-3.303-1.41-1.289 0-2.378.457-3.266 1.374-.888.916-1.332 2.021-1.332 3.316 0 1.283.463 2.389 1.387 3.317l14.159 14.238c.766.77 1.648 1.155 2.645 1.155.779 0 1.423-.257 1.934-.77.511-.513.767-1.16.767-1.942 0-1.002-.383-1.888-1.15-2.657l-10.6-10.647a1.562 1.562 0 0 0-1.095-.44 1.184 1.184 0 0 0-1.223 1.228c0 .39.152.751.456 1.081l7.481 7.513a.561.561 0 0 1 .183.403c0 .196-.189.483-.566.862-.377.378-.663.568-.858.568a.557.557 0 0 1-.401-.184l-7.48-7.513c-.767-.745-1.15-1.655-1.15-2.73 0-1.002.347-1.85 1.04-2.547.693-.696 1.539-1.045 2.536-1.045 1.07 0 1.977.385 2.719 1.155l10.6 10.646c1.217 1.198 1.825 2.633 1.825 4.307 0 1.43-.48 2.626-1.442 3.591z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

const OptimizationIcon: React.FC = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    style={{ height: '20px' }}
  >
    <title>Optimize</title>
    <path
      d="M16 27v-3h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H16zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8v3zm15-9v-3h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h18v3zM11 9V6h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H11zM6 9H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3v3zm2-5h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm15 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm-10 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

const GrayOptimizationIcon: React.FC = () => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    style={{ height: '20px' }}
  >
    <title>Optimize Disabled</title>
    <path
      d="M16 27v-3h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H16zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8v3zm15-9v-3h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h18v3zM11 9V6h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H11zM6 9H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3v3zm2-5h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm15 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm-10 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z"
      fill="#616668"
      fillRule="evenodd"
    />
  </svg>
);
const DeleteIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>Delete</title>
    <path
      d="M11.213 16L4.414 9.2a1 1 0 0 1 0-1.413l3.373-3.373a1 1 0 0 1 1.414 0l6.799 6.8 6.8-6.8a1 1 0 0 1 1.413 0l3.373 3.373a1 1 0 0 1 0 1.414L20.786 16l6.8 6.8a1 1 0 0 1 0 1.413l-3.373 3.373a1 1 0 0 1-1.414 0L16 20.786l-6.8 6.8a1 1 0 0 1-1.413 0l-3.373-3.373a1 1 0 0 1 0-1.414l6.8-6.799z"
      fill="red"
      fillRule="evenodd"
    />
  </svg>
);

const GrayDeleteIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>Delete Disabled</title>
    <path
      d="M11.213 16L4.414 9.2a1 1 0 0 1 0-1.413l3.373-3.373a1 1 0 0 1 1.414 0l6.799 6.8 6.8-6.8a1 1 0 0 1 1.413 0l3.373 3.373a1 1 0 0 1 0 1.414L20.786 16l6.8 6.8a1 1 0 0 1 0 1.413l-3.373 3.373a1 1 0 0 1-1.414 0L16 20.786l-6.8 6.8a1 1 0 0 1-1.413 0l-3.373-3.373a1 1 0 0 1 0-1.414l6.8-6.799z"
      fill="#616668"
      fillRule="evenodd"
    />
  </svg>
);

const GrayDuplicateIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>Duplicate Disabled</title>
    <g fill="#616668" fillRule="evenodd">
      <path
        d="M9.5 5.15V7.1h14.49a1 1 0 0 1 1 1v15.594h2a1 1 0 0 0 1-1V5.15a1 1 0 0 0-1-1H10.5a1 1 0 0 0-1 1z"
        fillRule="nonzero"
      />
      <path d="M21.818 28H6a1 1 0 0 1-1-1V9.912a1 1 0 0 1 1-1h15.818a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1z" />
    </g>
  </svg>
);
const ExitIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>sign-out</title>
    <path d="M24.807 18.297v-2.28h-8.189a.5.5 0 0 1-.5-.5V13.02a.5.5 0 0 1 .5-.5h8.189v-2.28a.5.5 0 0 1 .855-.353l3.99 4.029a.5.5 0 0 1 0 .703l-3.99 4.029a.5.5 0 0 1-.855-.352z" />
    <path
      d="M23.075 18.264v5.992a.5.5 0 0 1-.5.5h-8.188v4.434a.5.5 0 0 1-.724.447l-9.387-4.71A.5.5 0 0 1 4 24.482V2.5a.5.5 0 0 1 .5-.5h18.075a.5.5 0 0 1 .5.5v7.773a.5.5 0 0 1-.5.5h-.73a.5.5 0 0 1-.5-.5V3.748H7.461l6.65 3.357a.5.5 0 0 1 .275.446v15.457h6.925v-4.744a.5.5 0 0 1 .5-.5h.763a.5.5 0 0 1 .5.5z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

export {
  DuplicateIcon,
  GrayDeleteIcon,
  GrayEditIcon,
  EditIcon,
  DeleteIcon,
  ExitIcon,
  OptimizationIcon,
  AssignIcon,
  GrayDuplicateIcon,
  GrayOptimizationIcon
};
